export const SHOW_CREDIT_UI = false;

// Free tier (25 contacts/month, no card). Active as of 2026-07-22 after
// scripts/sql/free-tier.sql verified the credit_ledger CHECK constraint accepts
// the free-tier debit row shape (negative amount, no subscription_id/expires_at)
// against prod. Signed-in users with no subscription get 25 contacts/month,
// metered from the ledger; the paid flow is unchanged. Set to false to revert
// to the subscription-only paywall. Read server-side (business route,
// user/credits) and client-side (ai-search gate, nav meter, notices, settings).
export const FREE_TIER_ENABLED = true;
